import { render, staticRenderFns } from "./BottonieraRicerche.vue?vue&type=template&id=646a3f0c&scoped=true&"
import script from "./BottonieraRicerche.vue?vue&type=script&lang=js&"
export * from "./BottonieraRicerche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646a3f0c",
  null
  
)

export default component.exports